<script>
export default {
  name: "NestedList",
  props: {
    items: {
      type: Array,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    },
    listClass: {
      type: String,
      default: undefined
    },
    itemClass: {
      type: String,
      default: undefined
    }
  },
  methods: {
    hasChildren(item) {
      return Array.isArray(item.children) && item.children.length;
    }
  }
};
</script>

<template>
  <ul v-if="items.length" :class="[listClass, { [`${listClass}--depth-${depth}`]: listClass }]">
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="[itemClass, { [`${itemClass}--has-children`]: itemClass && hasChildren(item) }]"
    >
      <slot name="itemContent" v-bind="{ item, depth }">
        {{ item.name }}
      </slot>

      <NestedList
        v-if="hasChildren(item)"
        v-bind="{
          ...$props,
          items: item.children,
          depth: depth + 1
        }"
      >
        <template #itemContent="itemProps">
          <slot name="itemContent" v-bind="itemProps">
            {{ item.name }}
          </slot>
        </template>
      </NestedList>
    </li>
  </ul>
</template>
